/**
 * Legenda k farebnému prstencu so stavom signálu.
 *
 * Bez nej sú farby hádanka — a prstenec je tu práve preto, aby sa dalo na
 * prvý pohľad povedať, kde sa už dá zvárať a kde treba ešte dorobiť návrh.
 */
import React, { useState } from 'react';
import { SIGNAL_FARBY, SIGNAL_POPIS, SignalStav } from '../../utils/signalStatus';
import './SignalLegend.css';

interface Props {
  /** koľko zákazníckych splitterov je v ktorom stave */
  pocty: Record<SignalStav, number>;
  prahZelena: number;
  prahOranzova: number;
}

const PORADIE: SignalStav[] = ['dobry', 'slaby', 'prerusene', 'nezapojene'];

export const SignalLegend: React.FC<Props> = ({ pocty, prahZelena, prahOranzova }) => {
  const [zbalene, setZbalene] = useState(false);
  const spolu = PORADIE.reduce((s, k) => s + (pocty[k] || 0), 0);
  if (spolu === 0) return null;

  return (
    <div className={`signal-legend ${zbalene ? 'zbalene' : ''}`}>
      <button className="signal-legend-hlava" onClick={() => setZbalene(!zbalene)}>
        <span>📶 Signál na zákazníkovi</span>
        <span className="signal-legend-sipka">{zbalene ? '▸' : '▾'}</span>
      </button>

      {!zbalene && (
        <div className="signal-legend-telo">
          {PORADIE.map((stav) => (
            <div className="signal-legend-riadok" key={stav}>
              <span className="signal-legend-bod" style={{ background: SIGNAL_FARBY[stav] || '#ccc' }} />
              <span className="signal-legend-text">{SIGNAL_POPIS[stav]}</span>
              <span className="signal-legend-pocet">{pocty[stav] || 0}</span>
            </div>
          ))}
          <div className="signal-legend-prahy">
            zelená nad {prahZelena} dBm · oranžová do {prahOranzova} dBm
            <br />
            merané na výstupe splittra
          </div>
        </div>
      )}
    </div>
  );
};

export default SignalLegend;
